<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QXvI46/tc-custom/9781507300534.jpg?1721057645072" alt="This image is the cover for the book Skeleton Keys"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skeleton Keys
      </h1>
      <p class="bookDescription body article font2">
        <p>10 true paranormal stories examining true hauntings involving professional peopleHaunted houses and buildings, hotels,&amp;nbsp; homes, and more provide the backdrop for ghostly talesExperiences assembled from interviews and dramatized with storytelling techniques</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Klann
      </h2>
      
      <p class="authorDescription body article">John Klann has been interested in ghost stories since childhood and has made it a point to collect at least one from everyone he has ever known. At long last, his stockpile has found an outlet.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Schiffer Publishing Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?97377784